import { EntityEventAction, EventType } from '../enums'
import { Notification, NotificationEntity, PrometheusAlert } from '../types'

/**
 * Checks if the notification is an alert notification.
 */
export function isAlertNotification(
  notification: Notification<NotificationEntity | PrometheusAlert>
) {
  return notification.eventType === EventType.AlertEvent
}

/**
 * Checks if the notification is an entity notification.
 */
export function isEntityNotification(
  notification: Notification<NotificationEntity | PrometheusAlert>
) {
  return notification.eventType === EventType.EntityEvent
}

/**
 * Checks if the notification is an action request entity event.
 */
export function isActionRequestNotification(
  notification: Notification<NotificationEntity | PrometheusAlert>
) {
  if (!isEntityNotification(notification)) {
    return false
  }

  const entityEvent = notification as Notification<NotificationEntity>

  return (
    entityEvent.action === EntityEventAction.InsertActionRequest ||
    entityEvent.action === EntityEventAction.UpdateActionRequest ||
    entityEvent.action === EntityEventAction.RemoveActionRequest ||
    entityEvent.action === EntityEventAction.SoftRemoveActionRequest
  )
}

/**
 * Checks if the notification is a project membership entity event.
 */
export function isProjectMembershipNotification(
  notification: Notification<NotificationEntity | PrometheusAlert>
) {
  if (!isEntityNotification(notification)) {
    return false
  }

  const entityEvent = notification as Notification<NotificationEntity>

  return (
    entityEvent.action === EntityEventAction.InsertProjectMembership ||
    entityEvent.action === EntityEventAction.UpdateProjectMembership
  )
}

/**
 * Checks if the notification is user entity event.
 */
export function isUserNotification(
  notification: Notification<NotificationEntity | PrometheusAlert>
) {
  if (!isEntityNotification(notification)) {
    return false
  }

  const entityEvent = notification as Notification<NotificationEntity>

  return entityEvent.action === EntityEventAction.InsertUser
}

/**
 * Sort notifications by date.
 */
export function sortNotificationsByDate(
  notifications: Notification<NotificationEntity | PrometheusAlert>[]
) {
  return notifications.sort((a, b) => {
    const aDate = new Date(a.timestamp)
    const bDate = new Date(b.timestamp)

    // Sort in descending order.
    return bDate.getTime() - aDate.getTime()
  })
}
